module.exports = __webpack_public_path__ + "img/amazon-echodot.cd53e8d1.jpg";